'use strict';

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _get = function get(object, property, receiver) { if (object === null) object = Function.prototype; var desc = Object.getOwnPropertyDescriptor(object, property); if (desc === undefined) { var parent = Object.getPrototypeOf(object); if (parent === null) { return undefined; } else { return get(parent, property, receiver); } } else if ("value" in desc) { return desc.value; } else { var getter = desc.get; if (getter === undefined) { return undefined; } return getter.call(receiver); } };

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var _require = require('./baseEntity'),
    BaseEntity = _require.BaseEntity;

var _require2 = require('../resource'),
    AppRoleResource = _require2.AppRoleResource;

module.exports.AppRole = function (_BaseEntity) {
  _inherits(AppRole, _BaseEntity);

  _createClass(AppRole, null, [{
    key: '__name__',
    value: function __name__() {
      return 'approle';
    }
  }]);

  function AppRole(data) {
    _classCallCheck(this, AppRole);

    var _this = _possibleConstructorReturn(this, (AppRole.__proto__ || Object.getPrototypeOf(AppRole)).call(this));

    _this._entityName = 'de.ul.fob.security.AppRole';
    _this.name = null;

    _this.appRole = null;
    _get(AppRole.prototype.__proto__ || Object.getPrototypeOf(AppRole.prototype), 'init', _this).call(_this, data);
    return _this;
  }

  _createClass(AppRole, [{
    key: 'toPostData',
    value: function toPostData() {
      return this.genericJSON({
        fields: ['_id', 'name'],
        links: ['appRole']
      });
    }
  }, {
    key: 'fetchAppRole',
    value: function fetchAppRole() {
      return _get(AppRole.prototype.__proto__ || Object.getPrototypeOf(AppRole.prototype), 'genericResolve', this).call(this, 'appRole');
    }
  }, {
    key: 'fetchAll',
    value: function fetchAll() {
      return Promise.all([_get(AppRole.prototype.__proto__ || Object.getPrototypeOf(AppRole.prototype), 'genericResolve', this).call(this, 'appRole')]);
    }
  }, {
    key: 'fetchResource',
    value: function fetchResource() {
      if (typeof AppRoleResource === 'undefined') {
        return this.fetchAll();
      } else {
        return _get(AppRole.prototype.__proto__ || Object.getPrototypeOf(AppRole.prototype), 'fetchQuery', this).call(this, AppRoleResource);
      }
    }
  }]);

  return AppRole;
}(BaseEntity);


//////////////////
// WEBPACK FOOTER
// ./~/fobclient/lib/entity/appRole.js
// module id = jaIn
// module chunks = 0